import EventEmitter from 'events';

import Api from '../tools/api';
import util from '../tools/util';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isLoggedIn,
  isReady,
  isAdmin,
  isSuperAdmin,
  getUser,
  getCurrentOrgId,
  setCurrentOrgId,
  verifySessionKey,
  login,
  logout,
  get,
  post,
  del,
};

const POLL_MS = 1 * 1000;
const SESSION_KEY = 'SESSION_KEY';
const ORG_ID_KEY = 'MONP_ORG_ID';

let g_isReady = false;
let g_sessionKey: string | null = null;
let g_user: any = null;
let g_currentOrgId: any = null;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function isReady() {
  return g_isReady;
}
function isLoggedIn() {
  return Boolean(g_user);
}
function isAdmin() {
  return Boolean(g_user && g_user.is_admin);
}
function isSuperAdmin() {
  return Boolean(g_user && g_user.is_admin);
}
function getUser() {
  return g_user;
}
function getCurrentOrgId() {
  return g_currentOrgId;
}
function setCurrentOrgId(org_id) {
  g_currentOrgId = parseInt(org_id);
  window.localStorage[ORG_ID_KEY] = String(org_id);
  _emit('org_change');
}
function _getDefaultOrgId() {
  let ret;
  if (g_user && g_user.org_list && g_user.org_list.length > 0) {
    const saved_id = parseInt(window.localStorage[ORG_ID_KEY]);
    const found = g_user.org_list.find((o) => o.org_id === saved_id);
    if (found) {
      ret = found.org_id;
    }

    if (!ret) {
      ret = g_user.org_list[0].org_id;
    }
  }

  return ret;
}

function init() {
  g_sessionKey = window.localStorage[SESSION_KEY];
  if (g_sessionKey) {
    verifySessionKey(() => {
      g_isReady = true;
      _emit('ready');
    });
  } else {
    g_isReady = true;
    _emit('ready');
  }
}
function verifySessionKey(done) {
  const opts = {
    url: '/api/1/user/current',
  };
  get(opts, (err, body) => {
    if (err) {
      util.errorLog('UserStore.verifySessionKey: err:', err);
    } else {
      g_user = body;
      g_currentOrgId = _getDefaultOrgId();
      _emit('user_login');
    }
    done(err);
  });
}

function login(params: any, done: (err: string) => void) {
  const { user_name, password } = params;
  const opts = {
    url: '/api/1/user/login',
    body: { user_name, password },
  };
  Api.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserStore.login: err:', err, body);
      done(err);
    } else {
      g_sessionKey = body.user_session_key;
      window.localStorage[SESSION_KEY] = g_sessionKey;
      verifySessionKey(done);
    }
  });
}

function logout(done: (err: string) => void) {
  const opts = {
    url: '/api/1/user/logout',
  };
  post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserStore.logout: err:', err, body);
    }
    g_sessionKey = null;
    g_user = null;
    delete window.localStorage[SESSION_KEY];
    _emit('logout');
    done(err);
  });
}

function get(opts, done) {
  _request(opts, 'GET', done);
}
function post(opts, done) {
  _request(opts, 'POST', done);
}
function del(opts, done) {
  _request(opts, 'DELETE', done);
}

function _request(opts, method, done) {
  if (typeof opts === 'string') {
    opts = {
      url: opts,
    };
  }
  opts.method = method;
  if (!opts.query) {
    opts.query = {};
  }
  opts.query['user_session_key'] = g_sessionKey;
  Api.request(opts, done);
}
